import { ColorNeutralBlack, ColorNordicGrey1 } from 'autogen/design-tokens/tokens';
import Card from 'components/generic/card';
import styled, { css } from 'styled-components';

const StyledCard = styled(Card)<{ $isActive: boolean }>`
    border: 1px solid ${ColorNordicGrey1};
    margin-bottom: 0;
    overflow: visible;

    ${({ $isActive }) =>
        $isActive &&
        css`
            border-color: ${ColorNeutralBlack};
        `}
`;

export default StyledCard;
